
import { Component, Vue, Ref } from 'vue-property-decorator';
import { sectorsModule, categoriesModule, exportMarketsModule } from '../store';
import AnOverline from './AnOverline.vue';

const sorter = (a: { text: string }, b: { text: string } | undefined) => {
  return a.text.localeCompare(b?.text || '');
};

@Component({ components: { AnOverline } })
export default class SearchLanding extends Vue {
  @Ref() readonly form!: VuetifyForm;

  search = '';

  sector: string | null = null;

  category: string | null = null;

  exportMarket: string | null = null;

  get sectors(): SelectOptionItem[] {
    return sectorsModule.items
      .map(item => ({
        value: item.id || '',
        text: item.locale.name || '',
      }))
      .sort(sorter);
  }

  get categories(): SelectOptionItem[] {
    return categoriesModule.items
      .map(item => ({
        value: item.id || '',
        text: item.locale.name || '',
      }))
      .sort(sorter);
  }

  get exportMarkets(): SelectOptionItem[] {
    return exportMarketsModule.items
      .map(item => ({
        value: item.id || '',
        text: item.locale.title || '',
      }))
      .sort(sorter);
  }

  get filteredCategories() {
    const { sector } = this;
    if (!sector) {
      return this.categories;
    }
    return categoriesModule.items
      .filter(item => item.sector?.id === sector)
      .map(item => ({
        value: item.id || '',
        text: item.locale.name || '',
      }))
      .sort(sorter);
  }

  get sectorsLoading(): boolean {
    return sectorsModule.isLoading;
  }

  get categoriesLoading(): boolean {
    return categoriesModule.isLoading;
  }

  get exportMarketsLoading(): boolean {
    return exportMarketsModule.isLoading;
  }

  setSector(value: string | null) {
    this.sector = value;
    this.category = null;
  }

  submit(event: Event) {
    if (event) {
      event.preventDefault();
    }
    const { search, category, sector, exportMarket } = this;
    const data: SearchData = { search, category, sector, exportMarket };
    this.$emit('input', data);
  }

  mounted() {
    sectorsModule.fetchItemsIfNeeded();
    categoriesModule.fetchItemsIfNeeded();
    exportMarketsModule.fetchItemsIfNeeded();
  }
}
